import { render, staticRenderFns } from "./MFotoPendukung.vue?vue&type=template&id=0038c9f1&"
import script from "./MFotoPendukung.vue?vue&type=script&lang=js&"
export * from "./MFotoPendukung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports